import dropC from "./dropC.js";

export default function tailC(iter) {
  return dropC(1, iter);
}